<svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M0 19.2V4.2H3.6V3.8C3.6 2.8 3.9375 1.91667 4.6125 1.15C5.2875 0.383333 6.15 0 7.2 0C8.2 0 9.05 0.35 9.75 1.05C10.45 1.75 10.8 2.6 10.8 3.6V4.2H14.4V19.2H0ZM1.8 17.4H12.6V6H10.8V8.4H9V6H5.4V8.4H3.6V6H1.8V17.4ZM5.4 4.2H9V3.6C9 3.105 8.82325 2.68125 8.46975 2.32875C8.11625 1.97625 7.69125 1.8 7.19475 1.8C6.69825 1.8 6.275 1.97625 5.925 2.32875C5.575 2.68125 5.4 3.105 5.4 3.6V4.2Z"
		fill="currentColor"
	/>
</svg>
